import styled from 'styled-components';

export const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  z-index: ${({ theme }) => theme._ui.zIndexApp};

  height: calc(100vh - ${({ theme }) => theme.spacing['9Xl']});
  min-height: 200px;
  max-height: ${({ theme }) => theme._ui.maxHeightTotal};

  position: fixed;
  bottom: 5.5rem;
  left: initial;
  right: ${({ theme }) => theme.spacing['xl']};
  width: 25rem;
  background-color: ${({ theme }) => theme.background.default};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  box-shadow: rgba(24, 53, 88, 0.15) 0px 6px 35px 1px;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    inset: 0;
    width: 100%;

    box-sizing: border-box;
    height: 100dvh;
    padding-bottom: ${({ theme }) => theme._ui.minHeightQuestionInput};

    max-height: unset;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    border-radius: ${({ theme }) => theme.borderRadius.none};
  }
`;

export const StyledBodyContent = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow-y: auto;
`;
